import { use_effect } from '@/hooks/_base/use_effect';
import { service_drop } from './SERVICE__drop';

export function HOOK__drop_zone(id: string, ref: HTMLElement | null, on_drop: () => void) {
  use_effect(() => {
    return service_drop.register({
      id,
      get_rect: () => ref?.getBoundingClientRect() ?? null,
      on_drop,
    });
  }, [id, on_drop]);
}
